import React from 'react';
import { Field } from 'formik';
import PropTypes from 'prop-types';

export const Antiquity = ({ values, setValues, errors, touched }) => {
  return (
    <div>
      <label>Antigüedad *</label>
      <div>
        <Field
          type="radio"
          name="antiquity.type"
          value={1}
          checked={parseInt(values.antiquity.type) === 1}
          onClick={() =>
            setValues(prev => ({
              ...prev,
              antiquity: {
                ...prev.antiquity,
                years: ''
              }
            }))
          }
        />
        <label className="ps-2">A estrenar</label>
      </div>

      <div>
        <div>
          <Field
            type="radio"
            name="antiquity.type"
            value={2}
            checked={parseInt(values.antiquity.type) === 2}
          />
          <label className="ps-2">Años de antigüedad</label>
        </div>

        {parseInt(values.antiquity.type) === 2 && (
          <>
            <Field
              className="form-control form-control-sm ms-1"
              name="antiquity.years"
              style={{ maxWidth: '150px' }}
            />
            {errors.antiquity?.years && touched.antiquity?.years && (
              <label className="w-100 text-danger">
                {errors.antiquity.years}
              </label>
            )}
          </>
        )}
      </div>

      <div>
        <Field
          type="radio"
          name="antiquity.type"
          value={3}
          checked={parseInt(values.antiquity.type) === 3}
          onClick={() =>
            setValues(prev => ({
              ...prev,
              antiquity: {
                ...prev.antiquity,
                years: ''
              }
            }))
          }
        />
        <label className="ps-2 mb-0">En construcción</label>
      </div>
      {errors.antiquity?.type && touched.antiquity?.type && (
        <label className="w-100 text-danger">{errors.antiquity.type}</label>
      )}
    </div>
  );
};

Antiquity.propTypes = {
  values: PropTypes.object,
  setValues: PropTypes.func,
  errors: PropTypes.object,
  touched: PropTypes.object
};
